import type { ReactNode } from "react";

import LinkTabs from "@/components/link-tabs";
import PageHeader from "@/shell/page-header";

import { STANDARDS_TABS, tabHref, type StandardsTab } from "./standards-search";

const TAB_ITEMS = STANDARDS_TABS.map((t) => ({ label: t.label, href: tabHref(t.key) }));

// 공정 표준 화면 머리 — 제목·탭(항목·숫자 제안·Q&A) · 업계 집계 숫자는 두지 않는다(#383).
const StandardsShell = ({ tab, meta, children }: { tab: StandardsTab; meta?: string; children: ReactNode }) => (
  <>
    <PageHeader description="수치는 건설공사 표준품셈 기준이고 회사 보정으로 맞춥니다. 견적은 만들 때의 판을 그대로 유지합니다." meta={meta} title="공정 표준" />
    <LinkTabs activeHref={tabHref(tab)} aria-label="공정 표준 탭" className="mb-4" items={TAB_ITEMS} />
    {children}
  </>
);

export default StandardsShell;
